import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import * as input from './input/index.js';
import * as output from './output.js';
import * as dict from './dict.js';
import * as config from './config.js';
var registers = {
  input: input,
  output: output,
  dict: dict,
  config: config
};
var indices = {};
export var add = function add(ref) {
  var plugins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mainIndex = indices[ref] = {};

  for (var type in plugins) {
    if (type === 'config') {
      mainIndex.config = _defineProperty({}, ref, plugins.config);
      registers.config.add(ref, plugins.config);
      continue;
    }

    var typeIndex = mainIndex[type] = {};
    var typePlugins = plugins[type];

    for (var name in typePlugins) {
      var typePlugin = typePlugins[name];
      typeIndex[name] = true;
      registers[type].add(name, typePlugin);
    }
  }
};
export var remove = function remove(ref) {
  var mainIndex = indices[ref];

  for (var type in mainIndex) {
    var typeIndex = mainIndex[type];

    for (var name in typeIndex) {
      registers[type].remove(name);
    }
  }

  delete indices[ref];
};
export var has = function has(ref) {
  return ref in indices;
};
export var list = function list() {
  return Object.keys(indices);
};
export { input, output, dict, config };